import { Grid } from './Grid';

export interface LayerOptions {
  id?: string;
  name?: string;
  visible?: boolean;
  locked?: boolean;
}

let layerCounter = 0;

export function nextLayerId(): string {
  layerCounter += 1;
  return `layer-${Date.now().toString(36)}-${layerCounter.toString(36)}`;
}

/**
 * One drawable plane of the document. Layers are always the full document size;
 * transparency (empty char + transparent bg) does the masking, which keeps
 * compositing a straight index walk with no offset math per cell.
 */
export class Layer {
  readonly id: string;
  name: string;
  visible: boolean;
  locked: boolean;
  grid: Grid;

  constructor(width: number, height: number, opts: LayerOptions = {}) {
    this.id = opts.id ?? nextLayerId();
    this.name = opts.name ?? 'Layer';
    this.visible = opts.visible ?? true;
    this.locked = opts.locked ?? false;
    this.grid = new Grid(width, height);
  }

  clone(withNewId = false): Layer {
    const l = new Layer(this.grid.width, this.grid.height, {
      id: withNewId ? nextLayerId() : this.id,
      name: this.name,
      visible: this.visible,
      locked: this.locked,
    });
    l.grid = this.grid.clone();
    return l;
  }

  resize(width: number, height: number, offsetX = 0, offsetY = 0): void {
    this.grid = this.grid.resized(width, height, offsetX, offsetY);
  }
}
